// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1ouAX","blue":"Button_blue__3wtMF","mt-30":"Button_mt-30__1Lbws"};